/**
 * Calil 書誌 (CalilBook) の所蔵館 ID 抽出ヘルパー。
 *
 * Calil は `holdings` (確定) / `estimated_holdings` (推定) だけでなく、
 * どちらにも含まれない館の OPAC URL を `url` マップにだけ返してくる場合がある。
 * (例: 「三井 三菱」検索で三郷の URL のみが返るケース)
 *
 * そのため、3 つのソースを合算して重複排除した ID セットを返す。
 */

import type { CalilBook } from '@/api/types/calil'

/** book が持つ全ての所蔵候補館 ID (holdings ∪ estimated ∪ url) */
export const collectHoldingIds = (book: CalilBook): number[] => {
  const ids = new Set<number>()

  for (const id of book.holdings ?? []) ids.add(id)
  for (const id of book.estimated_holdings ?? []) ids.add(id)

  for (const key of Object.keys(book.url ?? {})) {
    const id = Number(key)
    if (Number.isFinite(id)) ids.add(id)
  }

  return Array.from(ids)
}
